import request from './request';
export default {
    html2pdf: function html2pdf(host, postData) {
        console.log(host, postData);
        return request({
            url: host + '/print/html2pdf',
            data: postData,
            method: 'post'
        });
    },
    html2pdfInfo: function html2pdfInfo(host, postData) {
        console.log(host, postData);
        return request({
            url: host + '/print/html2pdfInfo',
            data: postData,
            method: 'post'
        });
    },
    html2pdf2email: function html2pdf2email(host, postData) {
        return request({
            url: host + '/print/html2pdf2email',
            data: postData,
            method: 'post'
        });
    },
    savePrintInfo: function savePrintInfo(host, postData) {
        return request({
            url: host + '/print/savePrintInfo',
            data: postData,
            method: 'post'
        });
    },
    checkPermission: function checkPermission(host, postData) {
        return request({
            url: host + '/print/checkPermission',
            data: postData,
            method: 'post'
        });
    },
    latestPrintInfo: function latestPrintInfo(host, postData) {
        return request({
            url: host + '/print/latestPrintInfo',
            data: postData,
            method: 'post'
        });
    }
};